type LinkType = (typeof LINK_TYPES)[number];

const LINK_TYPES = ['highway', 'railway', 'trunk_road', 'other_road'] as const;

export type { LinkType };
export { LINK_TYPES };
